import {AfterViewInit, Component, Input} from '@angular/core';

@Component({
  selector: 'app-trustbox',
  templateUrl: './trustbox.component.html',
  styleUrls: ['./trustbox.component.scss']
})
export class TrustboxComponent implements AfterViewInit {

  @Input() width: number;
  @Input() height: number;
  @Input() templateId: string;
  @Input() theme = 'light';

  id = Math.floor(Math.random() * 999999);

  constructor() { }

  ngAfterViewInit(): void {
    const trustboxRef = document.getElementById(this.id.toString());
    window['Trustpilot'].loadFromElement(trustboxRef);
  }

}
